import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Drawer, Button, Icon, Input, message } from 'antd';
import ChooseCity from '../ChooseCity';
import { searchAddress, queryAddressByLonLat } from '@/service/common';
import { isApp, isMinProgram } from '@/util/h5Helper';
import './index.scss';

const DrawerWrap = props => {
  const {
    visible,
    title,
    confirmLoading,
    cancelTxt,
    okTxt,
    hideCancelBtn,
    hideOkBtn,
    contentClassName,
    onCancel,
    onOk,
    ...rest
  } = props;

  const [cityList, setCityList] = useState([]);
  const [activeCity, setActiveCity] = useState({
    cityName: '上海市',
    citycode: '310000',
  });
  const [chooseCityVisible, setChooseCityVisible] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [isGettingLocation, setIsGettingLocation] = useState(false);

  const funcQueryAddressByLonLat = async (params = {}) => {
    const res = await queryAddressByLonLat(params);
    if (res.code === 0) {
      setActiveCity({
        cityName: res?.data?.city || '上海市',
        citycode: res?.data?.citycode || '310000',
      });
      setIsGettingLocation(false);
    } else {
      setActiveCity({
        cityName: '上海市',
        citycode: '310000',
      });
    }
  };

  // 获取当前定位城市
  const getCurrentPosition = () => {
    // 仅在普通浏览器环境下执行，App和小程序环境下已有相关处理
    if (isApp() || isMinProgram()) {
      return;
    }

    if (!navigator.geolocation) {
      console.log('浏览器不支持地理位置API');
      return;
    }

    setIsGettingLocation(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        funcQueryAddressByLonLat({
          longitude,
          latitude,
        });
      },
      (error) => {
        console.error('获取位置信息失败:', error);
        setIsGettingLocation(false);
        setActiveCity({
          cityName: '上海市',
          citycode: '310000',
        });
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000 // 5分钟的缓存
      }
    );
  };

  // 组件挂载时获取当前城市
  useEffect(() => {
    if (visible) {
      getCurrentPosition();
    }
  }, [visible]);

  const onChooseCity = (item) => {
    console.log(item)
    setSearchValue('');
    setCityList([]);
    setActiveCity(item);
    setChooseCityVisible(false);
  };

  const onChooseAddress = () => {
    setChooseCityVisible(true);
  };

  const onSearch = async (value, type = 1) => {
    console.log('onSearch', value, type);
    const keyword = type === 1 ? value.target.value : value;
    console.log(keyword)
    setSearchValue(keyword);
    if (!keyword) {
      setCityList([]);
      return;
    }
    const res = await searchAddress({
      keyword,
      city: activeCity.cityName,
    });
    if (res.code === 0) {
      setCityList(res.result.data || []);
    }
  };

  const confirmSeach = () => {
    onSearch(searchValue, 2);
  }

  return (
    <Drawer
      className="drawer-choose-city"
      visible={visible}
      title='选择城市'
      width="100%"
      destroyOnClose
      closable={false}
      {...rest}
    >

      <div className="choose-city">
        <div className="choose-city-header">
          <div className="choose-city-header-left" onClick={onChooseAddress}>
            {isGettingLocation ? '定位中...' : <>
              {activeCity.cityName || '上海市'}
              <Icon className="choose-city-header-icon" type="down" />
            </>}
          </div>
          <div className="choose-city-header-title">
            <Input
              placeholder="请输入关键词查询"
              suffix={
                <Icon type="search" onClick={confirmSeach} />
              }
              value={searchValue}
              onChange={onSearch}
            />
          </div>
        </div>
        <div className='city-content'>
          {
            cityList.map((item, index) => (
              <div className='city-item' key={index} onClick={
                () => { onOk(item) }
              }>
                <div className='city-item-title'>
                  {item.name}
                </div>
                <div className='city-item-desc'>
                  {item.adname}{item.address}
                </div>
              </div>
            ))
          }
        </div>
        <ChooseCity
          visible={chooseCityVisible}
          onOk={onChooseCity}
          onCancel={() => {
            setChooseCityVisible(false);
          }}
        />
      </div>
    </Drawer>
  );
};

DrawerWrap.propTypes = {
  visible: PropTypes.bool,
  confirmLoading: PropTypes.bool,
  title: PropTypes.string,
  cancelTxt: PropTypes.string,
  okTxt: PropTypes.string,
  hideCancelBtn: PropTypes.bool,
  hideOkBtn: PropTypes.bool,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
};

DrawerWrap.defaultProps = {
  visible: false,
  confirmLoading: false,
  title: '新增',
  cancelTxt: '取消',
  okTxt: '提交',
  hideCancelBtn: false,
  hideOkBtn: false,
  contentClassName: '',
  onCancel: () => { },
  onOk: () => { },
};

export default DrawerWrap;
